__turbopack_context__.v({
  "container": "styles-module__YFvMnq__container",
  "placeholderWrapper": "styles-module__YFvMnq__placeholderWrapper",
  "wrapper": "styles-module__YFvMnq__wrapper",
});
